import { buildInventoryPrefill } from '../pipeline/CalculationWorksheet';

// Shared labels/keys for the Deletions table in Add/Edit Inventory
export const INVENTORY_DELETION_ROWS = [
  ['Wheels & Axles', 'maxSalesPriceCalculatorDeletedFields.wheelsAndAxles'],
  ['Factory Freight', 'maxSalesPriceCalculatorDeletedFields.factoryFreight'],
  ['Air Conditioner', 'maxSalesPriceCalculatorDeletedFields.airConditioner'],
  ['Tax From Invoice', 'maxSalesPriceCalculatorDeletedFields.taxFromInvoice'],
  ['HUD Dues/Fees', 'maxSalesPriceCalculatorDeletedFields.hudDuesFees'],
  ['Furniture/Entertainment Pack', 'maxSalesPriceCalculatorDeletedFields.furnitureEntertainmentPack'],
  ['Other Packs/Sales Allowances', 'maxSalesPriceCalculatorDeletedFields.otherPacksSalesAllowances'],
  ['Dealer Rebate', 'maxSalesPriceCalculatorDeletedFields.dealerRebate'],
  ['Advertising/Environmental Allowance', 'maxSalesPriceCalculatorDeletedFields.advertisingEnvironmentalAllowance'],
  ['Trim Out/Tape & Texture', 'maxSalesPriceCalculatorDeletedFields.trimOutTapeAndTexture'],
  ['Other', 'maxSalesPriceCalculatorDeletedFields.other']
];

// Map CalculationWorksheet buildInventoryPrefill() object into the flat form keys
// used by the legacy Add/Edit Inventory forms.
export const mapWorksheetPrefillToInventoryFormValues = worksheetPrefill => ({
  // Deletions
  'maxSalesPriceCalculatorDeletedFields.wheelsAndAxles': worksheetPrefill.wheelsAndAxles,
  'maxSalesPriceCalculatorDeletedFields.factoryFreight': worksheetPrefill.freight,
  'maxSalesPriceCalculatorDeletedFields.airConditioner': worksheetPrefill.airConditioner,
  'maxSalesPriceCalculatorDeletedFields.taxFromInvoice': worksheetPrefill.taxFromInvoice,
  'maxSalesPriceCalculatorDeletedFields.hudDuesFees': worksheetPrefill.hudDuesFees,
  'maxSalesPriceCalculatorDeletedFields.furnitureEntertainmentPack': worksheetPrefill.furnitureEntertainmentPack,
  'maxSalesPriceCalculatorDeletedFields.otherPacksSalesAllowances': worksheetPrefill.otherPacksSalesAllowances,
  'maxSalesPriceCalculatorDeletedFields.dealerRebate': worksheetPrefill.dealerRebate,
  'maxSalesPriceCalculatorDeletedFields.advertisingEnvironmentalAllowance':
    worksheetPrefill.advertisingEnvironmentalAllowance,
  'maxSalesPriceCalculatorDeletedFields.trimOutTapeAndTexture': worksheetPrefill.trimOutTapeAndTexture,
  'maxSalesPriceCalculatorDeletedFields.other': worksheetPrefill.otherDeletion,

  // Adds
  'maxSalesPriceCalculatorAddFields.factoryFreight': worksheetPrefill.addFactoryFreight,
  'maxSalesPriceCalculatorAddFields.airConditioner': worksheetPrefill.addAirConditioner,
  'maxSalesPriceCalculatorAddFields.taxFromInvoice': worksheetPrefill.addTaxFromInvoice,
  'maxSalesPriceCalculatorAddFields.hudDuesFees': worksheetPrefill.addHudDuesFees,
  'maxSalesPriceCalculatorAddFields.deliveryAndSet': worksheetPrefill.addDeliveryAndSet,
  'maxSalesPriceCalculatorAddFields.skirtingType': worksheetPrefill.addSkirtingType,
  'maxSalesPriceCalculatorAddFields.skirting': worksheetPrefill.addSkirting,
  'maxSalesPriceCalculatorAddFields.stepsDecks': worksheetPrefill.addStepsDecks,
  'maxSalesPriceCalculatorAddFields.numberOfSets': worksheetPrefill.addNumberOfSets,
  'maxSalesPriceCalculatorAddFields.dirtPad': worksheetPrefill.addDirtPad,
  'maxSalesPriceCalculatorAddFields.footers': worksheetPrefill.addFooters,
  'maxSalesPriceCalculatorAddFields.trimOutTapeAndTexture': worksheetPrefill.addTrimOutTapeAndTexture,
  'maxSalesPriceCalculatorAddFields.electricHookup': worksheetPrefill.addElectricHookup,
  'maxSalesPriceCalculatorAddFields.waterHookup': worksheetPrefill.addWaterHookup,
  'maxSalesPriceCalculatorAddFields.sewerHookup': worksheetPrefill.addSewerHookup,
  'maxSalesPriceCalculatorAddFields.gasHookup': worksheetPrefill.addGasHookup,
  'maxSalesPriceCalculatorAddFields.guttersAndDownspouts': worksheetPrefill.addGuttersAndDownspouts,
  'maxSalesPriceCalculatorAddFields.other': worksheetPrefill.addOther,
  'maxSalesPriceCalculatorAddFields.otherAmount': worksheetPrefill.addOtherAmount,

  maxSalesPriceSalesTax: worksheetPrefill.maxSalesPriceSalesTax,
  maxSalesPriceLandPurchasePrice: worksheetPrefill.landPurchasePrice,

  // Land improvements
  'maxSalesPriceLandImprovements.basement': worksheetPrefill.landBasement,
  'maxSalesPriceLandImprovements.grading': worksheetPrefill.landGrading,
  'maxSalesPriceLandImprovements.brickBlockSkirting': worksheetPrefill.landBrickBlockSkirting,
  'maxSalesPriceLandImprovements.permanentFoundation': worksheetPrefill.landPermanentFoundation,
  'maxSalesPriceLandImprovements.carport': worksheetPrefill.landCarport,
  'maxSalesPriceLandImprovements.permits': worksheetPrefill.landPermits,
  'maxSalesPriceLandImprovements.deck': worksheetPrefill.landDeck,
  'maxSalesPriceLandImprovements.porch': worksheetPrefill.landPorch,
  'maxSalesPriceLandImprovements.driveway': worksheetPrefill.landDriveway,
  'maxSalesPriceLandImprovements.septic': worksheetPrefill.landSeptic,
  'maxSalesPriceLandImprovements.electricalHookup': worksheetPrefill.landElectricalHookup,
  'maxSalesPriceLandImprovements.sewerHookup': worksheetPrefill.landSewerHookup,
  'maxSalesPriceLandImprovements.footers': worksheetPrefill.landFooters,
  'maxSalesPriceLandImprovements.waterHookup': worksheetPrefill.landWaterHookup,
  'maxSalesPriceLandImprovements.garage': worksheetPrefill.landGarage,
  'maxSalesPriceLandImprovements.well': worksheetPrefill.landWell,
  'maxSalesPriceLandImprovements.gasHookup': worksheetPrefill.landGasHookup,
  'maxSalesPriceLandImprovements.other': worksheetPrefill.landOther
});

// Convenience helper: given a full inventory object, return the flat form values
// that include worksheet defaults.
export const buildInventoryFormValuesWithWorksheetDefaults = inventory => {
  const base = inventory ? inventory : {};
  const worksheetPrefill = buildInventoryPrefill(base);
  return mapWorksheetPrefillToInventoryFormValues(worksheetPrefill);
};

// Convert flat form fields back into the nested shape expected by the backend schema.
// This mirrors the structure in inventoryModel.maxSalesPriceCalculator* and maxSalesPriceLandImprovements.
const toNum = val => {
  if (val === null || val === undefined || val === '') return undefined;
  const n = parseFloat(String(val).replace(/[^0-9.-]/g, ''));
  return Number.isFinite(n) ? n : undefined;
};

export const buildWorksheetPayloadFromForm = form => ({
  maxSalesPriceCalculatorDeletedFields: {
    wheelsAndAxles: toNum(form['maxSalesPriceCalculatorDeletedFields.wheelsAndAxles']),
    factoryFreight: toNum(form['maxSalesPriceCalculatorDeletedFields.factoryFreight']),
    airConditioner: toNum(form['maxSalesPriceCalculatorDeletedFields.airConditioner']),
    hudDuesFees: toNum(form['maxSalesPriceCalculatorDeletedFields.hudDuesFees']),
    furnitureEntertainmentPack: toNum(form['maxSalesPriceCalculatorDeletedFields.furnitureEntertainmentPack']),
    otherPacksSalesAllowances: toNum(form['maxSalesPriceCalculatorDeletedFields.otherPacksSalesAllowances']),
    dealerRebate: toNum(form['maxSalesPriceCalculatorDeletedFields.dealerRebate']),
    advertisingEnvironmentalAllowance: toNum(
      form['maxSalesPriceCalculatorDeletedFields.advertisingEnvironmentalAllowance']
    ),
    trimOutTapeAndTexture: toNum(form['maxSalesPriceCalculatorDeletedFields.trimOutTapeAndTexture']),
    other: toNum(form['maxSalesPriceCalculatorDeletedFields.other']),
    taxFromInvoice: toNum(form['maxSalesPriceCalculatorDeletedFields.taxFromInvoice'])
  },
  maxSalesPriceCalculatorAddFields: {
    factoryFreight: toNum(form['maxSalesPriceCalculatorAddFields.factoryFreight']),
    airConditioner: toNum(form['maxSalesPriceCalculatorAddFields.airConditioner']),
    hudDuesFees: toNum(form['maxSalesPriceCalculatorAddFields.hudDuesFees']),
    deliveryAndSet: toNum(form['maxSalesPriceCalculatorAddFields.deliveryAndSet']),
    skirting: toNum(form['maxSalesPriceCalculatorAddFields.skirting']),
    skirtingType:
      form['maxSalesPriceCalculatorAddFields.skirtingType'] ?? undefined,
    stepsDecks: toNum(form['maxSalesPriceCalculatorAddFields.stepsDecks']),
    numberOfSets: toNum(form['maxSalesPriceCalculatorAddFields.numberOfSets']),
    dirtPad: toNum(form['maxSalesPriceCalculatorAddFields.dirtPad']),
    footers: toNum(form['maxSalesPriceCalculatorAddFields.footers']),
    trimOutTapeAndTexture: toNum(form['maxSalesPriceCalculatorAddFields.trimOutTapeAndTexture']),
    electricHookup: toNum(form['maxSalesPriceCalculatorAddFields.electricHookup']),
    waterHookup: toNum(form['maxSalesPriceCalculatorAddFields.waterHookup']),
    sewerHookup: toNum(form['maxSalesPriceCalculatorAddFields.sewerHookup']),
    gasHookup: toNum(form['maxSalesPriceCalculatorAddFields.gasHookup']),
    guttersAndDownspouts: toNum(form['maxSalesPriceCalculatorAddFields.guttersAndDownspouts']),
    other: form['maxSalesPriceCalculatorAddFields.other'] || undefined,
    otherAmount: toNum(form['maxSalesPriceCalculatorAddFields.otherAmount']),
    taxFromInvoice: toNum(form['maxSalesPriceCalculatorAddFields.taxFromInvoice'])
  },
  maxSalesPriceSalesTax: toNum(form.maxSalesPriceSalesTax),
  maxSalesPriceLandPurchasePrice: toNum(form.maxSalesPriceLandPurchasePrice),
  maxSalesPriceLandImprovements: {
    basement: toNum(form['maxSalesPriceLandImprovements.basement']),
    grading: toNum(form['maxSalesPriceLandImprovements.grading']),
    brickBlockSkirting: toNum(form['maxSalesPriceLandImprovements.brickBlockSkirting']),
    permanentFoundation: toNum(form['maxSalesPriceLandImprovements.permanentFoundation']),
    carport: toNum(form['maxSalesPriceLandImprovements.carport']),
    permits: toNum(form['maxSalesPriceLandImprovements.permits']),
    deck: toNum(form['maxSalesPriceLandImprovements.deck']),
    porch: toNum(form['maxSalesPriceLandImprovements.porch']),
    driveway: toNum(form['maxSalesPriceLandImprovements.driveway']),
    septic: toNum(form['maxSalesPriceLandImprovements.septic']),
    electricalHookup: toNum(form['maxSalesPriceLandImprovements.electricalHookup']),
    sewerHookup: toNum(form['maxSalesPriceLandImprovements.sewerHookup']),
    footers: toNum(form['maxSalesPriceLandImprovements.footers']),
    waterHookup: toNum(form['maxSalesPriceLandImprovements.waterHookup']),
    garage: toNum(form['maxSalesPriceLandImprovements.garage']),
    well: toNum(form['maxSalesPriceLandImprovements.well']),
    gasHookup: toNum(form['maxSalesPriceLandImprovements.gasHookup']),
    other: toNum(form['maxSalesPriceLandImprovements.other'])
  }
});

